import React, { useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Form, Button, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';

function CasesShippedReportForm() {
  const [startDate, setStartDate] = useState('2024-08-01');
  const [endDate, setEndDate] = useState('2024-08-31');
  const [format, setFormat] = useState('');

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    switch (name) {
      case 'startDate':
        setStartDate(value);
        break;
      case 'endDate':
        setEndDate(value);
        break;
      case 'format':
        setFormat(value);
        break;
      default:
        break;
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Add form submission logic here if needed
  };

  return (
    <div className=" mt-5">
      <div >
        <div className="col-md-5">
          <h2 className="text-center mb-4" style={{ color: 'black' }}>Parameters</h2>
          <Form onSubmit={handleSubmit} className="p-4 border rounded" style={{ borderTop: '5px solid #007bff' }}>
            <Form.Group as={Row} controlId="cases-shipped-start-date">
              <Form.Label column md={4} style={{ textAlign: 'right' }}>Start Date <span className="text-danger">*</span></Form.Label>
              <Col md={8}>
                <Form.Control
                  type="date"
                  name="startDate"
                  value={startDate}
                  onChange={handleInputChange}
                  required
                />
              </Col>
            </Form.Group>

            <Form.Group as={Row} controlId="cases-shipped-end-date">
              <Form.Label column md={4} style={{ textAlign: 'right' }}>End Date <span className="text-danger">*</span></Form.Label>
              <Col md={8}>
                <Form.Control
                  type="date"
                  name="endDate"
                  value={endDate}
                  onChange={handleInputChange}
                  required
                />
              </Col>
            </Form.Group>

            <Form.Group as={Row} controlId="report_cases_shipped_format">
              <Form.Label column md={4} style={{ textAlign: 'right' }}>Format <span className="text-danger">*</span></Form.Label>
              <Col md={8}>
                <Form.Control
                  as="select"
                  name="format"
                  value={format}
                  onChange={handleInputChange}
                >
                  <option value="">On Screen</option>
                  <option value="csv">CSV (Excel)</option>
                </Form.Control>
              </Col>
            </Form.Group>

            <Form.Group as={Row}>
              <Col sm={{ span: 8, offset: 4 }}>
                <Link to="/Addcaseshipped">
                  <Button
                    id="pay-per-task-submit"
                    type="button"
                    variant="primary"
                    className="w-100 mt-2"
                    style={{
                      backgroundColor: '#004aad',
                      borderColor: '#004aad',
                      marginTop: '10px',
                    }}
                  >
                    Run
                  </Button>
                </Link>
              </Col>
            </Form.Group>
          </Form>
        </div>
      </div>
      </div>
  );
}

export default CasesShippedReportForm;
